import Ajax from '@utils/ajax';

export default {
  flagContentModalSeen(options = {}) {
    return Ajax.post({
      url: `/users/me/user_account_flags/flag_content_modal_seen`,
      ...options,
    });
  },
  showLinktreeProfile(options = {}) {
    return Ajax.get({
      url: `/users/me/user_account_flags/show_linktree_profile`,
      ...options,
    });
  },

  flagLinktreeProfileBannerClosed(options = {}) {
    return Ajax.post({
      url: `/users/me/user_account_flags/flag_linktree_profile_banner_closed`,
      ...options,
    });
  },

  flagLinktreeProfilePromptClicked(options = {}) {
    return Ajax.post({
      url: `/users/me/user_account_flags/flag_linktree_profile_prompt_clicked`,
      ...options,
    });
  },

  get(options = {}) {
    return Ajax.get({
      url: `/users/me/user_account_flags`,
      ...options,
    });
  },
};
